"use strict";

var _slicedToArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _client = require("@apollo/client");
var _core = require("@material-ui/core");
var _util = require("@bento-core/util");
var _textEditComponent = _interopRequireDefault(require("./textEditComponent"));
var _defaultStyle = _interopRequireDefault(require("./defaultStyle"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var BodyView = function BodyView(_ref) {
  var classes = _ref.classes,
    data = _ref.data,
    changeUserBasicInfo = _ref.changeUserBasicInfo,
    editTool = _ref.editTool;
  var getMyUser = data.getMyUser;
  var _ref2 = (0, _react.useState)(getMyUser.firstName),
    _ref3 = _slicedToArray(_ref2, 2),
    firstName = _ref3[0],
    setFirstName = _ref3[1];
  var _ref4 = (0, _react.useState)(getMyUser.lastName),
    _ref5 = _slicedToArray(_ref4, 2),
    lastName = _ref5[0],
    setLastName = _ref5[1];
  var _ref6 = (0, _react.useState)(getMyUser.organization),
    _ref7 = _slicedToArray(_ref6, 2),
    organization = _ref7[0],
    setOrganization = _ref7[1];
  var _ref8 = (0, _client.useMutation)(changeUserBasicInfo, {
      context: {
        clientName: 'userService'
      },
      fetchPolicy: 'no-cache',
      onCompleted: function onCompleted(responseData) {
        var userDetails = (0, _util.getFromLocalStorage)('userDetails');
        setFirstName(responseData.updateMyUser.firstName);
        setLastName(responseData.updateMyUser.lastName);
        setOrganization(responseData.updateMyUser.organization);
        userDetails.firstName = responseData.updateMyUser.firstName;
        userDetails.lastName = responseData.updateMyUser.lastName;
        userDetails.organization = responseData.updateMyUser.organization;
        (0, _util.storeInLocalStorage)('userDetails', userDetails);
      },
      onError: function onError() {
        /* Check here for what needs to be changed */
      }
    }),
    _ref9 = _slicedToArray(_ref8, 1),
    mutate = _ref9[0];
  /* const { data: editSuccessData } = response; */
  var completeSave = function completeSave(value, field) {
    var variables = {
      userInfo: {
        firstName: firstName,
        lastName: lastName,
        organization: organization
      }
    };
    variables.userInfo[field] = value;
    mutate({
      variables: variables
    });
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.profile_body_container
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.splitBodyColumn1
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.textContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.textLabel
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: classes.labelSpan
  }, "Account Type: ")), /*#__PURE__*/_react.default.createElement(_core.TextField, {
    className: classes.textField,
    value: _util.custodianUtils.getAuthenticatorName(getMyUser.IDP || ''),
    inputProps: {
      readOnly: true,
      className: classes.textFieldInput
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.textContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.textLabel
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: classes.labelSpan
  }, "Last Name: ")), /*#__PURE__*/_react.default.createElement(_textEditComponent.default, {
    data: "".concat(lastName),
    customOptions: {
      alt: 'Edit last name',
      field: 'lastName'
    },
    onSave: completeSave,
    editTool: editTool
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.textContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.textLabel
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: classes.labelSpan
  }, "First Name: ")), /*#__PURE__*/_react.default.createElement(_textEditComponent.default, {
    data: "".concat(firstName),
    customOptions: {
      alt: 'Edit first name',
      field: 'firstName'
    },
    onSave: completeSave,
    editTool: editTool
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.textContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.textLabel
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: classes.labelSpan
  }, "Organization:")), /*#__PURE__*/_react.default.createElement(_textEditComponent.default, {
    customOptions: {
      alt: 'edit organization',
      field: 'organization',
      useLargerField: true
    },
    data: organization,
    onSave: completeSave,
    editTool: editTool
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.splitBodyColumn2
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: ""
  }));
};
var _default = (0, _core.withStyles)(_defaultStyle.default, {
  withTheme: true
})(BodyView);
exports.default = _default;